import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import deliverConfigUser from '../components/productTable.vue';

formCreate.component('deliver_config_user', deliverConfigUser);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'deliver_config_form',
    };
  },
  async created() {
    await this.getFormRule('deliver_config_form');
  },
  methods: {
    // 设置规则
    setRule(item) {
      return item;
    },
    // 渲染完成后执行
    formComplete() {
      console.log('formConfig——————————', this.formConfig);
      // const { code, row } = this.formConfig;
      // if (code === 'view') {
      //     console.log(11112222);
      //     request.post('/dms/dmsterminalcontractorder/query', {
      //         id: row.id,
      //     }).then((res) => {
      //         const { result } = res;
      //         if (res.success) {
      //             this.setValue({
      //                 ...result,
      //                 totalAmountAll: result.totalAmount,
      //             });
      //         }
      //     });
      // }
    },

    submit() {
      const formData = this.getFormData();
      if (formData) {
        console.log('🚀 ~ submit ~ formData:', formData);
        if (!formData.userList) {
          this.$message({
            type: 'error',
            message: '请选择用户',
          });
          return false;
        }
        const userListArr = [];
        if (formData.userList) {
          formData.userList.forEach((item) => {
            userListArr.push({
              userCode: item.userCode,
              userName: item.userName,
              fullName: item.fullName,
              positionCode: item.positionCode,
              positionName: item.positionName,
              orgCode: item.orgCode,
              orgName: item.orgName,
            });
          });
        }
        const params = {
          orderListType: formData.orderListType,
          userList: userListArr,
        };

        request.post('/mdm/orderPermission/save', params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },

  },
};
